// Seed de pedidos del simulador de Comida para llevar.
// Compartido por MockPedidosPage (kanban/lista) y el Dashboard del simulador
// (resumen del día), para que ambos muestren los mismos datos mock.

const TODAY = new Date().toLocaleDateString("en-CA", { timeZone: "Europe/Madrid" });
const TOMORROW = new Date(Date.now() + 86400000).toLocaleDateString("en-CA", { timeZone: "Europe/Madrid" });
// Hora a la que se hizo cada pedido (24/9/2026): «Pedido 12:41 · hace 6 min» en la tarjeta.
const AGO = (min) => new Date(Date.now() - min * 60_000).toISOString();
// Hora «HH:MM» (Europe/Madrid) dentro de `min` minutos, redondeada a 5: la entrega del pedido a
// domicilio de la demo siempre cae justo después de «va de camino», sea la hora que sea.
const SOON = (min) => {
  const d = new Date(Math.ceil((Date.now() + min * 60_000) / 300_000) * 300_000);
  return d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Madrid" });
};

export const INITIAL_PEDIDOS = [
  {
    order_id: "ord-001", contact_name: "Carlos Ruiz", phone: "+34611223344", order_type: "web",
    items: [{ qty: 1, name: "Paella valenciana" }, { qty: 2, name: "Coca-Cola 33cl" }],
    total: "17.90", status: "Nuevo", pickup_time: "13:30", pickup_date: TODAY, payment_status: "pending",
    created_at: AGO(6), notes: "Sin cebolla en la paella, por favor",
    // Solo simulador: enseña el chip «Cliente nuevo» (el historial demo siempre tiene 3+ pedidos).
    demo_first_order: true,
  },
  {
    order_id: "ord-002", contact_name: "María López", phone: "+34622334455", order_type: "carta_dia",
    items: [{ qty: 1, name: "Albóndigas en salsa" }, { qty: 1, name: "Tortilla de patatas" }],
    total: "15.80", status: "Nuevo", pickup_time: "13:00", pickup_date: TODAY, payment_status: "paid",
    created_at: AGO(18), paid_at: AGO(17), stripe_payment_intent_id: "pi_demo",
  },
  {
    order_id: "ord-003", contact_name: "Ana García", phone: "+34633445566", order_type: "menu_dia",
    items: [{ qty: 2, name: "Lentejas con chorizo" }, { qty: 1, name: "Agua mineral 50cl" }],
    total: "16.80", status: "Listo", pickup_time: "12:30", pickup_date: TODAY, payment_status: "pending",
    created_at: AGO(52),
    status_history: [{ status: "Preparando", at: AGO(40) }, { status: "Listo", at: AGO(12) }],
  },
  {
    order_id: "ord-004", contact_name: "Pedro Martínez", phone: "+34644556677", order_type: "crm_manual",
    items: [{ qty: 1, name: "Merluza al horno" }, { qty: 1, name: "Flan de huevo casero" }],
    total: "16.00", status: "Listo", pickup_time: "14:00", pickup_date: TODAY, payment_status: "pending",
    created_at: AGO(75),
    status_history: [{ status: "Listo", at: AGO(20) }],
  },
  {
    order_id: "ord-005", contact_name: "Isabel Sánchez", phone: "+34655667788", order_type: "mostrador",
    items: [{ qty: 3, name: "Croquetas de jamón ibérico" }],
    total: "19.50", status: "Entregado", pickup_time: "12:00", pickup_date: TODAY, payment_status: "paid",
    created_at: AGO(95), paid_at: AGO(95), payment_method: "efectivo", tpv_ticket_number: 14,
  },
  {
    // Repite pedido con el botón «Nuevo pedido» de su confirmación anterior (ver foodChatsMock.js).
    order_id: "ord-006", contact_name: "Roberto Fernández", phone: "+34666778899", order_type: "carta_dia",
    items: [{ qty: 1, name: "Cocido madrileño" }],
    total: "11.50", status: "Nuevo", pickup_time: "14:30", pickup_date: TODAY, payment_status: "pending",
    created_at: AGO(130),
  },
  {
    order_id: "ord-007", contact_name: "Laura Gómez", phone: "+34677889900", order_type: "web",
    items: [{ qty: 2, name: "Pollo al ajillo" }, { qty: 1, name: "Arroz con leche" }],
    // total = platos 22,50 − premio de fidelidad 2,25 (10 % del subtotal de platos; sin envío).
    total: "20.25", status: "Nuevo", pickup_time: "20:00", pickup_date: TOMORROW, payment_status: "pending",
    created_at: AGO(3),
    // Gastó el premio de su tarjeta de fidelidad (15/10/2026): chip verde en la tarjeta y fila en el detalle.
    loyalty_reward: { nombre: "10 % de descuento", tipo: "percent", valor: 10, importe: 2.25 },
  },
  {
    // Pedido de ejemplo para la columna reservada "Esperando pago" (pago online
    // obligatorio, mode !== "optional"): solo se ve en el kanban cuando la política
    // de MockCobrosOnlineCard NO es "optional". `payment_deadline_at` se calcula al
    // cargar el módulo para que la cuenta atrás mock arranque con minutos reales.
    order_id: "ord-008", contact_name: "Jorge Navarro", phone: "+34688990011", order_type: "web",
    items: [{ qty: 1, name: "Menú del día" }, { qty: 1, name: "Agua mineral 50cl" }],
    total: "13.50", status: "Esperando pago", pickup_time: "14:15", pickup_date: TODAY, payment_status: "pending",
    payment_deadline_at: new Date(Date.now() + 8 * 60_000).toISOString(),
    created_at: AGO(4), payment_link: "https://checkout.stripe.com/demo",
  },
  {
    // A domicilio y pagado online por el Flow (28/9/2026): su chat enseña confirmación v5 con
    // ticket, aviso de pago recibido y «va de camino». La hora de entrega sale del reloj para que
    // el chat y la tarjeta cuadren a cualquier hora de la demo.
    order_id: "ord-009", contact_name: "Laura Jiménez", phone: "+34699001122", order_type: "carta_dia",
    items: [{ qty: 1, name: "Pollo al ajillo" }, { qty: 1, name: "Croquetas de jamón ibérico" }],
    total: "18.50", status: "Listo", pickup_time: SOON(20), pickup_date: TODAY, payment_status: "paid",
    fulfillment: "delivery", delivery_address: "C/ de Colón 14, 3º B", delivery_fee_cents: 250,
    created_at: AGO(40), paid_at: AGO(39), stripe_payment_intent_id: "pi_demo_2",
    status_history: [{ status: "Listo", at: AGO(6) }],
  },
  {
    // Cancelado por el cliente con el botón «Cancelar pedido» de la confirmación del Flow.
    order_id: "ord-010", contact_name: "Diego Torres", phone: "+34610203040", order_type: "carta_dia",
    items: [{ qty: 2, name: "Paella valenciana" }, { qty: 1, name: "Ensaladilla rusa" }],
    total: "31.70", status: "Cancelado", pickup_time: "14:30", pickup_date: TODAY, payment_status: "pending",
    created_at: AGO(35), cancelled_at: AGO(31), cancelled_by: "customer",
    status_history: [{ status: "Cancelado", at: AGO(31), by: "cliente" }],
  },
];

export default INITIAL_PEDIDOS;
